export default mainNav => {
    // console.log('mainNav');

    const locationInfos = mainNav.querySelector('.location-infos');
    const locationInfosTime = locationInfos.querySelector('.time');
    const locationInfosHours = locationInfosTime.querySelector('.hours');
    const locationInfosMinutes = locationInfosTime.querySelector('.minutes');
    const locationInfosTemperature = locationInfos.querySelector('.temperature');
    const btnMenu = mainNav.querySelector('.btn.menu');
    const btnMenuText = btnMenu.querySelector('.text');
    const menuHeaderContainer = mainNav.querySelector('.menu-header-container');
    const menuItemLinkBtns = mainNav.querySelectorAll('button.menu-item-link');

    function toggleMenu() {
        btnMenu.classList.toggle('open');
        menuHeaderContainer.classList.toggle('open');
        btnMenuText.textContent = btnMenuText.textContent === 'Menu' ? 'Fermer' : 'Menu';
    }

    function updateTime() {
        const date = new Date();

        locationInfosHours.textContent = (date.getHours() < 10 ? '0' : '') + date.getHours();
        locationInfosMinutes.textContent = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    }

    function updatTemp(temp) {
        locationInfosTemperature.textContent = Math.round(temp);
    }

    function sendAjax() {
        const ajaxData = new FormData();
        const request = new XMLHttpRequest();

        request.open('POST', 'https://api.openweathermap.org/data/2.5/weather?q=Paris,FR&APPID=c5ef50568fb7f4e2e600bb7810c49342&units=metric&lang=fr', true);
        request.send(ajaxData);

        request.onprogress = () => {
            // console.log('onprogress...');
        };

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(response);
            }

            updatTemp(response.main.temp);
        };

        request.onerror = () => {
            // console.log('onerror...');
        };
    }

    function hideAllSubMenuItem() {
        mainNav.querySelectorAll('.sub-menu-item').forEach(subMenuItem => {
            subMenuItem.classList.remove('show');
        });
    }

    function toggleSubMenuItem(event) {
        const subMenuItem = event.target.parentNode.querySelector('.sub-menu-item');

        subMenuItem.classList[subMenuItem.classList.contains('show') ? 'remove' : 'add']('show');
    }

    btnMenu.addEventListener('click', toggleMenu);

    menuItemLinkBtns.forEach(menuItemLinkBtn => {
        menuItemLinkBtn.addEventListener('click', event => {
            hideAllSubMenuItem();
            toggleSubMenuItem(event);
        });
    });

    updateTime();
    sendAjax();

    setInterval(() => updateTime(), 1000);
};
